import _slicedToArray from "/home/keoadmin/agent/_work/76/s/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { globalHistory } from "@reach/router";
import { useState } from "react";
function makeAdapter() {
  var adapter = {
    replace: function replace(location) {
      globalHistory.navigate(location.search || "?", {
        replace: true,
        state: location.state
      });
    },
    push: function push(location) {
      globalHistory.navigate(location.search || "?", {
        replace: false,
        state: location.state
      });
    },
    get location() {
      return globalHistory.location;
    }
  };
  return adapter;
}
var ReachAdapter = function ReachAdapter(_ref) {
  var children = _ref.children;
  var _useState = useState(makeAdapter),
    _useState2 = _slicedToArray(_useState, 1),
    adapter = _useState2[0];
  return children(adapter);
};
export { ReachAdapter };